/**
 * Fokusmanagement-Funktion manageFocus.setFocus()
 * 
 * Diese Funktion verwaltet den Fokus innerhalb eines bestimmten Menüs und ermöglicht 
 * die Navigation mit der Tabulatortaste sowie das Schließen des Menüs über die Escape-Taste 
 * oder einen Schließen-Button. Zusätzlich kann das Menü bei einem Klick außerhalb geschlossen 
 * werden, wenn die entsprechende Option aktiviert ist.
 * 
 * @param {string} selector - Der jQuery-Selector für das Menü, dessen Fokus verwaltet werden soll.
 * @param {Object} options - Optionen zur Anpassung des Verhaltens der Funktion.
 * @param {string} [options.returnElement] - Ein optionaler Selector für das Element, 
 *        zu dem der Fokus zurückkehren soll, wenn das Menü geschlossen wird.
 * @param {function} [options.closeFunction] - Eine optionale Funktion, die aufgerufen wird, 
 *        wenn das Menü geschlossen wird. Dies kann verwendet werden, um zusätzliche 
 *        Bereinigungs- oder Schließlogik auszuführen.
 * @param {string} [options.closeButtonSelector] - Ein optionaler Selector für den Schließen-Button. 
 *        Wenn dieser Selector angegeben wird, wird ein Event-Listener hinzugefügt, 
 *        der das Menü schließt, wenn der Button geklickt wird.
 * @param {boolean} [options.closeOnTabEnd] - Ein optionaler Boolean, der angibt, 
 *        ob das Menü geschlossen werden soll, wenn das letzte fokussierbare Element 
 *        mit der Tabulatortaste erreicht wird.
 * @param {boolean} [options.closeOnOutsideClick] - Ein optionaler Boolean, der angibt, 
 *        ob das Menü geschlossen werden soll, wenn außerhalb des Menüs geklickt wird.
 * 
 * @example
 * // Beispielaufruf der manageFocus-Funktion
 * manageFocus('#myMenu', {
 *     returnElement: '#myButton',
 *     closeFunction: function() {
 *         console.log('Menu closed');
 *     },
 *     closeButtonSelector: '.my-custom-close-button', // Optional
 *     closeOnTabEnd: true, // Menü schließen, wenn das letzte Element erreicht wird
 *     closeOnOutsideClick: true // Menü schließen, wenn außerhalb geklickt wird
 * });
 */


window.manageFocus = {
	keydownBound : false, // Flag, um zu überprüfen, ob das keydown-Event bereits gebunden ist
	transitionBound : false, // Flag, um zu überprüfen, ob das transitionend-Event bereits gebunden ist
	outsideClickBound : false, // Flag, um zu überprüfen, ob das click-Event bereits gebunden ist
	setFocus : function (selector, options = {}) {
	    const menu = $(selector);
	    const focusableElements = menu.find('a:not([tabindex="-1"]), input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
	    const firstFocusable = focusableElements.first();
	    const lastFocusable = focusableElements.last();
	    const returnElement = options.returnElement || null; 
	    const closeFunction = options.closeFunction || null; 
	    const closeButtonSelector = options.closeButtonSelector || null; 
	    const closeOnTabEnd = options.closeOnTabEnd || false; 
	    const closeOnOutsideClick = options.closeOnOutsideClick || false; // Neue Option für das Schließen bei Klick außerhalb
		var clickCount = 0;
	
	    function bindKeydown() {
	        if (!manageFocus.keydownBound) {
	            menu.on('keydown', handleKeydown);
	            manageFocus.keydownBound = true; // Setze das Flag, dass das Event gebunden ist
	        }
	    }
	
	    function unbindKeydown() {
	        menu.off('keydown', handleKeydown); // Entferne den Event-Listener für die Tasteneingabe
	        manageFocus.keydownBound = false; // Setze das Flag zurück
	    }
	
	    function bindTransitionEnd() {
	        if (!manageFocus.transitionBound) {
	            menu.on('transitionend', handleTransitionEnd);
	            manageFocus.transitionBound = true; // Setze das Flag, dass das Event gebunden ist
	        }
	    }
	
	    function unbindTransitionEnd() {
	        menu.off('transitionend', handleTransitionEnd); // Entferne den Event-Listener für das Transition-Ende
	        manageFocus.transitionBound = false; // Setze das Flag zurück
	    }
	
	    function bindOutsideClick() {
	        if (!manageFocus.outsideClickBound) {
	            $(document).on('click', handleOutsideClick);
	            manageFocus.outsideClickBound = true; // Setze das Flag, dass das Event gebunden ist
	        }
	    }
	
	    function unbindOutsideClick() {
	        $(document).off('click', handleOutsideClick); // Entferne den Event-Listener
	        manageFocus.outsideClickBound = false; // Setze das Flag zurück
	    }
	
	    function handleKeydown(e) {
	        if (e.key === 'Tab') {
	            if (e.shiftKey) { // Shift + Tab
	                if (document.activeElement === firstFocusable[0]) {
	                    e.preventDefault();
	                    lastFocusable.focus();
	                }
	            } else { // Tab
	                if (document.activeElement === lastFocusable[0]) {
	                    e.preventDefault();
	                    if (closeOnTabEnd) {
	                        closeMenu(); // Schließe das Menü, wenn die Option aktiviert ist
	                    } else {
	                        firstFocusable.focus(); // Gehe zurück zum ersten Element
	                    }
	                }
	            }
	        } else if (e.key === 'Escape') { // Escape-Taste
	            e.preventDefault();
	            closeMenu();
	        }
	    }
	
	    function handleTransitionEnd() {
	        firstFocusable.focus(); // Setze den Fokus auf das erste Element, wenn die Transition abgeschlossen ist
	        bindKeydown(); // Binde das keydown-Event, nachdem die Transition abgeschlossen ist
	    }
	
	    // Funktion zum Schließen des Menüs
	    function closeMenu() {
	        unbindKeydown(); // Entferne den Event-Listener für die Tasteneingabe
	        unbindTransitionEnd(); // Entferne den Event-Listener für das Transition-Ende
	        if (closeFunction) {
	            closeFunction(); // Rufe die übergebene Schließfunktion auf
	        }
	        if (returnElement) {
	            $(returnElement).focus(); // Fokus zurück zum aufrufenden Element
	        }
	        if (closeOnOutsideClick) {
				unbindOutsideClick(); // Entferne den Event-Listener für Klicks außerhalb
	        }
	    }
	
	    // Funktion zum Schließen des Menüs bei Klick außerhalb
	    function handleOutsideClick(e) {
			clickCount++;
	        if (clickCount > 1 && !menu.is(e.target) && menu.has(e.target).length === 0) {
	            closeMenu(); // Schließe das Menü, wenn der Klick außerhalb erfolgt
	        }
	    }
	
	    // Füge einen Event-Listener für den Schließen-Button hinzu, wenn ein Selector übergeben wurde
	    if (closeButtonSelector) {
	        const closeButton = menu.find(closeButtonSelector);
	        closeButton.on('click', function(e) {
	            e.preventDefault();
	            closeMenu(); // Rufe die Schließlogik auf
	            closeButton.off('click'); // Entferne den Event-Listener für den Schließen-Button
	        });
	    }
	
	    // Binde das transitionend-Event beim ersten Aufruf
	    bindTransitionEnd();
	
	    // Initiales Setzen des Fokus und Binden des keydown-Events
	    if (menu.is(':visible')) {
	        firstFocusable.focus();
	        bindKeydown();
		    // Binde den Event-Listener für Klicks außerhalb, wenn die Option aktiviert ist
		    if (closeOnOutsideClick) {
				bindOutsideClick()
		    }
	    }
	}
};
/* *************************
 * 	hover actions
 * ************************* */
var hoverActions = {
    init: function() {
        $(document).on('mouseenter mouseleave', '.hover-add-class', function(e) {
            var $this = $(this);
            var selector = $this.data('hv-selector') || this;
            var className = $this.data('hv-class') || 'hover';
            
            $(selector).toggleClass(className, e.type === 'mouseenter');
        });
    }
};

$(document).ready(function() {
	hoverActions.init();
});

/* *******************
 * Comfortcontact
 * ****************** */
function comfortcontactShow(elementID, btn) {
	$('#' + elementID).addClass('show-box');
	$('#' + elementID).attr('aria-hidden',false);
	$('[aria-controls="' + elementID +'"]').attr('aria-expanded','true');
    manageFocus.setFocus('#' + elementID, {
        returnElement: btn, // Das aufrufende Element
        closeFunction: function() {
        	comfortcontactHide(elementID);
        },
        closeOnTabEnd: true,
		closeOnOutsideClick:true
    }); // Fokusmanagement aufrufen
}
function comfortcontactHide(elementID) {
	$('#' + elementID).removeClass('show-box');
	$('#' + elementID).attr('aria-hidden',true);
	$('[aria-controls="' + elementID +'"]').attr('aria-expanded','false');
	$(document).on("mouseup.hideDocClick", function (e) {
	    // Prüfe, ob das geklickte Ziel NICHT die Box selbst oder ein Kind der Box ist
	    if (!$(e.target).closest('.comfortcontact-box').length) {
	        comfortcontactHide();
	        $(document).off('.hideDocClick');
	    }
	});
}

$(document).ready(function () {
	/*
	$( ".btn-comfortcontact" ).hover(
	      function() {
	    	comfortcontactShow('comfortcontact', this);
	      },
	      function() {
	      	comfortcontactHide('comfortcontact', this);
	      }
	);
	*/
	$( ".btn-comfortcontact" ).click(function() {
		comfortcontactShow('comfortcontact', this);
	});
});
/* *************************
 * 	nav
 * ************************* */
window.nav = {
	menuContainerId : 'main-menu',
	navbarNavSelector : '#mainnav .navbar-nav',
	dropdown : $("#mainnav .navbar-nav > .dropdown"),
	dropdownDropdown : $("#mainnav .navbar-nav .dropdown .dropdown > .dropdown-item"),
	dropdownToggle : $(".dropdown-toggle"),
	dropdownMenu : $(".dropdown-menu"),
	showClass : "show",
	navMobiledDdClass : '.mobile-dd-toggle',
	navMobileBreakpoint:0,
	init:function(){
		/*
		nav.dropdown.hover(
	      function() {
			if ($(window).width() > nav.navMobileBreakpoint) nav.openHoverMenu(this);
	      },
	      function() {
	  		if ($(window).width() > nav.navMobileBreakpoint) nav.closeHoverMenu();
	      }
	    );
	    $(nav.navbarNavSelector + ' .nav-link, ' + nav.navbarNavSelector + ' .dropdown-item').on('click', function() {
	        $('#' + nav.menuContainerId).collapse('hide');
	    });
		*/
		/* mobile-dd-toggle */
		/* mobile-dd-toggle */
		if (nav.navMobiledDdClass != '') {
			$("#mainnav " + nav.navMobiledDdClass).click(nav.switchMobileDdToggle);
	        $("#mainnav " + nav.navMobiledDdClass).keydown(function(e) {
		        if (e.key === "Enter") nav.switchMobileDdToggle(e);
	        });
		}
	},
	switchMobileDdToggle:function(e) {
			if ($(e.currentTarget).attr("aria-expanded") == 'false') {
		        nav.openMenu($(e.currentTarget).closest('.dropdown'));
			} else {
		        nav.closeMenu($(e.currentTarget).closest('.dropdown'));
			}
	    	e.stopPropagation();
	        e.preventDefault();
	},
	openMenu:function(e){
		var $this = $(e);
	    $this.addClass(nav.showClass);
	    $this.children(nav.dropdownToggle).attr("aria-expanded", "true");
	    $this.children(nav.dropdownMenu).addClass(nav.showClass);
		$this.children(nav.dropdownToggle).children(nav.navMobiledDdClass).attr("aria-expanded", "true");
	},
	closeMenu:function(e){
		if (e) {
	    	var $this = e;			
		} else {
	    	var $this = $(nav.dropdown);
		}
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownToggle).attr("aria-expanded", "false");
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);

		$this.find(nav.navMobiledDdClass).first().attr("aria-expanded", "false");
			
	},
	openHoverMenu:function(e){
		nav.closeHoverMenu();
		nav.openMenu(e);
		nav.dropdown.click(
	      function(e) {
                nav.closeHoverMenu();
		});
	},
	closeHoverMenu:function(e){
		nav.closeMenu(nav.dropdown);			
	},
};

// SwitchHeader — Einfacher Wechsel von Header-Zuständen beim Scrollen
// Nutzung:
// 1) Ziel-Element anlegen, z. B. <div id="switchheader"></div>
// 2) Modul initialisieren:
//    switchHeader.init({
//      selector: '#switchheader',
//		switchPosition:'300',
//      before: () => document.querySelector('.header-bgcontainer').classList.add('bg-secondary'),
//      after:  () => document.querySelector('.header-bgcontainer').classList.remove('bg-secondary'),
//      debounceMs: 60 // optional, Standard: 80
//		offset: -0
//    });
//    - before wird ausgeführt, wenn das Fenster die Position des Elements erreicht oder überschreitet.
//    - after wird ausgeführt, wenn das Fenster wieder oberhalb der Position ist.
//    - Existiert das Element nicht, wird before sofort ausgeführt (wie im Original).
// 3) Optionale Methoden:
//    switchHeader.trigger()           // manueller Check
//    switchHeader.setSelector('#id')  // Selector ändern

window.switchHeader = (function () {
  const noop = () => {};

  function debounce(fn, wait = 0) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  let selector = '#switchheader';
  let onBefore = noop;
  let onAfter = noop;
  let lastState = null;
  let element = null;
  let switchPosition = null;
  let offset = 0; // Neuer Parameter
 
  function updateElement() {
    element = document.querySelector(selector);
  }

  function getOffsetTop(el) {
    if (!el) return null;
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  }

  function check() {
    // 1. Position ermitteln: Element hat Vorrang vor switchPosition
    let basePosition = 0;
    const elTop = getOffsetTop(element);

    if (elTop !== null) {
      basePosition = elTop;
    } else if (switchPosition !== null) {
      basePosition = switchPosition;
    }

    // 2. Offset dazurechnen
    const threshold = basePosition + offset;
    const scrolledPast = window.pageYOffset >= threshold;

    if (scrolledPast === lastState) return;
    lastState = scrolledPast;

    // Falls gescrollt (true) -> After, sonst -> Before
    if (scrolledPast) onAfter();
    else onBefore();
  }

  return {
    init({ 
      selector: sel = '#switchheader', 
      before = noop, 
      after = noop, 
      debounceMs = 80, 
      switchPosition: pos = null,
      offset: off = 0 // Neuer Parameter in init
    } = {}) {
      selector = sel;
      onBefore = typeof before === 'function' ? before : noop;
      onAfter = typeof after === 'function' ? after : noop;
      
      // Sicherstellen, dass Werte Zahlen sind
      switchPosition = pos !== null ? Number(pos) : null;
      offset = Number(off);
      
      updateElement();

      // Falls weder Element noch feste Position existieren, abbrechen
      if (!element && switchPosition === null) return;

      check();
      const handler = debounce(check, debounceMs);
      window.addEventListener('scroll', handler, { passive: true });
      window.addEventListener('resize', () => {
        updateElement();
        handler();
      }, { passive: true });
    },
    trigger() { check(); },
    setSelector(sel) { selector = sel; updateElement(); check(); }
  };
})();

/**
 * SmoothScrollHandler
 * 
 * Verwendung:
 * const scrollHandler = new SmoothScrollHandler({ 
 *    offset: 140,            // Standard Offset für normale Anker
 *    accordionOffset: 100,   // Spezieller Offset für Accordion-Elemente
 *    speed: 600              // Animationsgeschwindigkeit in ms
 * });
 * 
 * Voraussetzung: jQuery und Bootstrap JS müssen geladen sein.
 */
class BootstrapScrollHandler {
    constructor(options = {}) {
        // Zwei verschiedene Offsets konfigurierbar
        this.defaultOffset = options.offset || 140;
        this.accordionOffset = options.accordionOffset || 90; 
        this.speed = options.speed || 600;
        
        // CSS Smooth Scroll deaktivieren für volle JS-Kontrolle
        $('html').css('scroll-behavior', 'auto !important');
        
        this.init();
    }

    init() {
        // 1. Initialer Check (Deep Link)
        $(window).on('load', () => {
            if (window.location.hash) {
                window.scrollTo(0, 0); 
                setTimeout(() => this.handleTarget(window.location.hash), 100);
            }
        });

        // 2. Klick-Handler
        $(document).on('click', 'a[href*="#"]', (e) => {
            const link = e.currentTarget;
            if (link.pathname === window.location.pathname && link.hash) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                this.handleTarget(link.hash);
                history.pushState(null, null, link.hash);
            }
        });
    }

    handleTarget(hash) {
        const $target = $(hash);
        if (!$target.length) return;

        // Fallunterscheidung: Accordion vs. normaler Anker
        const isAccordion = $target.hasClass('collapse') || $target.hasClass('accordion-collapse');
        const currentOffset = isAccordion ? this.accordionOffset : this.defaultOffset;

        if (isAccordion) {
            if ($target.hasClass('show')) {
                this.scrollToElement($target, currentOffset);
            } else {
                // Erst scrollen, wenn Bootstrap fertig ausgeklappt hat (verhindert Ruckeln)
                $target.one('shown.bs.collapse', () => {
                    this.scrollToElement($target, currentOffset);
                });
                $target.collapse('show');
            }
        } else {
            this.scrollToElement($target, currentOffset);
        }
    }

    scrollToElement($element, offsetValue) {
        // Position erst bei Funktionsaufruf messen (wichtig nach dem Aufklappen!)
        const targetPos = $element.offset().top - offsetValue;

        $('html, body').stop(true).animate({
            scrollTop: targetPos
        }, this.speed, 'swing');
    }
}
window.BootstrapScrollHandler = BootstrapScrollHandler;